const translations = {
    airTemperature: 'Air Temperature: ',
    applicationDate: 'Application Date: ',
    applicationSite: 'Application Site: ',
    applicator: 'Applicator: {{name}}',
    drone: 'Drone: {{name}}',
    endTime: 'End Time: ',
    fahrenheit: '\u00b0F',
    humidity: 'Humidity: ',
    mph: 'MPH',
    percent: '%',
    startTime: 'Start Time: ',
    windDirection: 'Wind Direction: ',
    windGustSpeed: 'Wind Gust Speed: ',
    windSpeed: 'Wind Speed: ',
    workOrderNumber: 'Work Order Number (AcreConnect): '
};

export default translations;
